import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  attrs: {
    addressLine1: {
      key: 'address_line_1'
    },
    addressLine2: {
      key: 'address_line_2'
    },
    addressLine3: {
      key: 'address_line_3'
    },
    sublocality2: {
      key: 'sublocality_2'
    },
    sublocality3: {
      key: 'sublocality_3'
    },
    administrativeDistrictLevel1: {
      key: 'administrative_district_level_1'
    },
    administrativeDistrictLevel2: {
      key: 'administrative_district_level_2'
    },
    administrativeDistrictLevel3: {
      key: 'administrative_district_level_3'
    }
  }
});